import { put } from "redux-saga/effects";

import * as satisfactionActions from "actions/satisfaction";

export function* replaceAccountSatisfactionRecentResponses(data) {
  yield put(
    satisfactionActions.replaceAccountSatisfactionRecentResponses(data)
  );
}
